import "@hotwired/turbo-rails"
import "../controllers"
import * as bootstrap from "bootstrap"
import "../lib/bootstrap_tooltip_safety"
import "../lib/bootstrap_modal_safety"
import "../lib/bootstrap_alert_safety"
import "trix"
import "@rails/actiontext"
import "../routes"
import "leaflet"
import "leaflet-polylinedecorator"
import { DotLottie } from "@lottiefiles/dotlottie-web"
import { mountDrive, unmountDrive } from "../modules/drive/mount.js"
import { installChatScrollTurboHooks } from "../lib/chat_scroll_persist.js"

installChatScrollTurboHooks()

// Make DotLottie available globally
window.DotLottie = DotLottie

document.addEventListener("DOMContentLoaded", () => mountDrive())
document.addEventListener("turbo:load", () => mountDrive())
document.addEventListener("turbo:before-cache", () => unmountDrive())
